// removed by extract-text-webpack-plugin
module.exports = {"headLine":"fhtX1cSw5MhEiFM7CQs8Q"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylists/MyPlaylists.scss
// module id = 1355
// module chunks = 1